// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SecurityScanTwoToneSvg from "@ant-design/icons-svg/es/asn/SecurityScanTwoTone";
import AntdIcon from '../components/AntdIcon';

var SecurityScanTwoTone = function SecurityScanTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanTwoToneSvg
  }));
};

SecurityScanTwoTone.displayName = 'SecurityScanTwoTone';
export default React.forwardRef(SecurityScanTwoTone);